import { gql } from '@apollo/client';

export const CORE_PROJECT_CATEGORY_FIELDS = gql`
  fragment CoreProjectCategoryFields on ProjectCategory {
    id
    name
  }
`;

export const CORE_PROJECT_TYPE_FIELDS = gql`
  fragment CoreProjectTypeFields on ProjectType {
    id
    name
  }
`;

export const CORE_FACULTY_FIELDS = gql`
  fragment CoreFacultyFields on Faculty {
    id
    name
    abbreviation
    departments {
      id
      name
      abbreviation
    }
  }
`;

export const CORE_DEPARTMENT_FIELDS = gql`
  fragment CoreDepartmentFields on Department {
    id
    name
    abbreviation
  }
`;
